import {create} from 'zustand';

const useAgentSessionStore = create((set) => ({
  sessions: [],
  activeSessionId: null,
  isLoading: false,
  hasMore: false,

  setSessions: (sessions) => set({sessions}),
  setActiveSession: (id) => set({activeSessionId: id}),
  setIsLoading: (isLoading) => set({isLoading}),
  setHasMore: (hasMore) => set({hasMore}),

  addSession: (session) =>
    set((state) => ({
      sessions: [session, ...state.sessions],
    })),

  updateSessionTitle: (id, title) =>
    set((state) => ({
      sessions: state.sessions.map((s) =>
        s.uuid === id ? {...s, title} : s,
      ),
    })),

  appendSessions: (sessions) =>
    set((state) => ({
      sessions: [...state.sessions, ...sessions],
    })),

  reset: () =>
    set({
      sessions: [],
      activeSessionId: null,
      isLoading: false,
      hasMore: false,
    }),

  startNewConversation: () => set({activeSessionId: null}),
}));

export default useAgentSessionStore;
